<style lang="less">
    @import "../../../styles/radioAndCheckbox.less";
</style>
<template>
    <div id="copyrightRegistration">
        <div class="topNav">
            <img class="img" src="../../../viewsGangAn/assets/index.png" alt="">
            <div class="r">></div>
            <div class="text" @click="onUrl('/gananCopyrightRegistration')">{{form.regType == '02'?'版权登记':'版权区块链存证'}}</div>
            <div class="r">></div>
            <div class="text active">{{form.regType == '02'?'版权登记':'版权区块链存证'}}填写</div>
        </div>
        <div class="shztBox shztBox2" v-if="auditStatus == 'reject_enable'">
            <img src="./images/xxb.png" alt="">
            <span class="audit_text" >驳回可编辑：{{rejectReason || '' }} </span>
        </div>
        <div class="topTitle">
            <div class="title">{{form.regType == '02'?'版权登记':'版权区块链存证'}}</div>
            <div class="msg" v-if="form.regType == '02'">为文学、艺术、科学等作品申请著作权相关登记</div>
            <div class="msg" v-else>创作完成进行版权区块链存证，需要时申请版权登记证书，证书时间为版权区块链存证时间</div>
        </div>
        <div class="copyrightRegistration">
            <div class="myTitleBox">
                <div class="myTitle">{{form.regType == '02'?'版权登记':'版权区块链存证'}}</div>
            </div>
            <Row class-name="row_item" style="height:50px">
                <Col class="col_label"><p>权利权属：</p></Col>
                <Col class="col_value">
                    <RadioGroup class="radio_group monitor_type"  v-model="form.copyrightType" @on-change="powerChange" v-if="userInfo.accountType == 'person'">
                        <Radio v-for="(item,index) in powers" class="radio_item" :disabled="item.value == 3 ||  item.value == 4 ?true: false" :label="item.value" :key="index"> <span class="radio_item_name">{{ item.label }}</span></Radio>
                    </RadioGroup>
                    <RadioGroup class="radio_group monitor_type"  v-model="form.copyrightType" @on-change="powerChange" v-else-if="userInfo.accountType == 'enterprise'">
                        <Radio v-for="(item,index) in powers" class="radio_item" :disabled="item.value == 1?true: false" :label="item.value" :key="index"> <span class="radio_item_name">{{ item.label }}</span></Radio>
                    </RadioGroup>
                    <RadioGroup class="radio_group monitor_type"  v-model="form.copyrightType" @on-change="powerChange" v-else>
                        <Radio v-for="(item,index) in powers" class="radio_item" :label="item.value" :key="index"> <span class="radio_item_name">{{ item.label }}</span></Radio>
                    </RadioGroup>
                </Col>
            </Row>
            <Row class-name="row_item" style="height:50px">
                <Col class="col_label"><p>权利权属方式：</p></Col>
                <Col class="col_value">

                    <RadioGroup class="radio_group monitor_type"
                                v-model="form.powerBy"
                                @on-change="powerChange2">
                      <span v-if="form.copyrightType == 1">
                        <Radio v-for="(item,index) in powersPerson" class="radio_item" :label="item.value" :key="index">
                            <span class="radio_item_name">{{ item.label }}</span>
                        </Radio>
                      </span>
                      <span v-if="form.copyrightType == 3">
                        <Radio v-for="(item,index) in powersEnterprise" class="radio_item" :label="item.value" :key="index">
                            <span class="radio_item_name">{{ item.label }}</span>
                        </Radio>
                      </span>
                      <span v-if="form.copyrightType != 1 && form.copyrightType != 3">
                        <Radio v-for="(item,index) in powers2" class="radio_item" :label="item.value" :key="index">
                            <span class="radio_item_name">{{ item.label }}</span>
                        </Radio>
                      </span>
                    </RadioGroup>
                </Col>
            </Row>
            <!-- <Row class-name="row_item">
                <Col class="col_label"></Col>
                <Col class="col_value">
                    <p class="power_des">*{{powers_des}}</p>
                </Col>
            </Row> -->
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item" style="height: auto;min-height: 70px;padding-top: 20px;">
                <Col class="col_label"><p>作者：</p></Col>
                <Col class="col_value" style="flex-wrap: wrap;">
                    <div v-for="(item,index) in autors" :key="index" class="show_Picture_autor">
                        <div class="showSc_autor" disabled="true">
                            <p class="autors_class" disabled="true">{{item.name}}</p>
                            <img @click.stop="deleteAutor(item)" class="showshanchu"
                                 src="@/assets/regist/autor_delete.png" alt='版权登记'/>
                        </div>
                    </div>
                    <p class="addBtn" @click="addAutor('autor')">添加作者</p>
                </Col>
            </Row>

            <Row class-name="row_item" style="height: auto;min-height: 70px;">
                <Col class="col_label"><p>著作权人：</p></Col>
                <Col class="col_value" style="flex-wrap: wrap;">
                    <div v-for="(item,index) in obligees" :key="index" class="show_Picture_autor">
                        <div class="showSc_autor" disabled="true">
                            <p class="autors_class" disabled="true">{{item.name}}</p>
                            <img @click.stop="deleteObligee(item)" class="showshanchu"
                                 src="@/assets/regist/autor_delete.png" alt='版权登记'/>
                        </div>
                    </div>
                    <p class="addBtn" @click="addAutor('obligee')">添加著作权人</p>
                </Col>
            </Row>

            <Row class-name="row_item">

                <Col class="col_label"><p>作品类型：</p></Col>
                <Col class="col_value">
                    <Select ref="worksType" :clearable="true" v-model="form.workType" placeholder="请选择作品类型"
                            class="selectWidth" @on-change="workTypeChange">
                        <Option v-for="(item,index) in workTypes" :value="item.code" :key="index">{{item.name}}</Option>
                    </Select>
                </Col>
            </Row>

            <Row class-name="row_item">
                <Col class="col_label"><p>作品名称：</p></Col>
                <Col class="col_value">
                    <input placeholder="请输入作品名称" v-model.trim="form.workFullname" class="form_input_1" maxlength="100"/>
                </Col>
            </Row>

            <Row class-name="row_item_1" :style="{'height':worksList.length>0?'310px':'200px'}">
                <Col class="col_label top20"><p>作品文件：</p></Col>
                <Col class="col_value">
                    <div class="certList_right">
                        <div class="certList_right_top">
                            <MyUploadHw :index="1" ref="workFile" :oldShowList="worksList" :fileMultiue="true"
                                        textContent="添加作品样本"
                                        :maxNumber="maxNumber"
                                        :accept="otherFileFormat"
                                        :pictureTypes="52428800" :documnetTypes="52428800" :videoAndMusics="1073741824" :otherTypes="52428800"
                                        :maxSizes="52428800"
                                        @listentochildevent="showmessagefromchild"/>
                            <div class="showtextDf">
                                <div>温馨提示：</div>
                              <p>图片格式限:jpg/jpeg/png，文本格式限：doc/docx/pdf/txt</p>
                              <p>音频格式限:wav/mp3/wma/acc，视频格式限：mp4(H264编码格式)/flv</p>
                              <p>文件名只能包括：中文、大小写字母、数字和下划线</p>
                                <p>支持5个作品文件，单个大小{{form.workCategory == 'media'?'1G':'50M'}}以内。</p>

                                <!-- <p v-if="this.workType_fileAccept !='' && this.workType_fileAccept !='*'">
                                    3、上传{{this.workType_fileAccept}}格式的文件</p> -->

                            </div>
                        </div>
                        <div style="display:flex;justify-content:flex-start;">
                            <div v-for="(item,index) in worksList" :key="index" class="show_Picture">
                                <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                                    <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                                    <p>上传中</p>

                                    <div :style="{height:item.uploadProgress + '%'}"
                                         class="upload_progress_shadow"></div>
                                </div>

                                <div v-else class="showSc">

                                    <!--                                    <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" alt="图片过大" />-->
                                    <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                                         :src="item.url" alt="图片过大"/>
                                    <!--                                    <progressive-img  :src="[item.isIcon?item.url:default_icon]" alt="" @click="workDownLoad(item)"-->
                                    <!--                                                      style="cursor: pointer;width: 103px;height: 70px;" />-->
                                    <span class="showDelete"><img @click.stop="deleteList(item)" class="showshanchu"
                                                                  src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                                </div>

                                <Tooltip max-width="300" placement="bottom"
                                         :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                                    <div style="line-height: 1">{{item.name ?
                                        item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>



            <Row class-name="row_item">
                <Col class="col_label"><p>作品创作性质：</p></Col>
                <Col class="col_value">
                    <Select v-model="form.creativeType" placeholder="请选择作品创作性质" class="selectWidth">
                        <Option v-for="(option, index) in creativeTypes" :value="option.value" :key="index">
                            {{option.label}}
                        </Option>
                    </Select>
                </Col>
            </Row>

            <Row v-if="form.creativeType != '1' && form.creativeType != ''" class-name="row_item_1">
              <Col class="col_value">
                <RadioGroup class="radio_group monitor_type"  v-model="form.creativeTypeValue" @on-change="creativeTypeChange" >
                  <Radio style="width: 550px; margin-left: 140px;" v-for="(item,index) in creativeTypeList" class="radio_item" :label="item.value" :key="index">
                    <span class="radio_item_name">{{ item.label }}</span>
                  </Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row v-if="form.creativeType != '1' && form.creativeType != '' && form.creativeTypeValue == '3'" class-name="row_item_1" :style="{'height':workInstruction.length>0?'auto':'226px',paddingBottom:'24px',boxSizing:'border-box'}">
                <Col class="col_label top20"><p>创作性质授权书：</p></Col>
                <Col class="col_value">
                    <div class="certList_right">
                        <div class="certList_right_top">
                            <MyUploadHw :index="2" ref="encolosureFile" :oldShowList="workInstruction" :fileMultiue="true"
                                        accept=".jpg,.png,.pdf,.doc,.docx,.xlsx" textContent="附件上传"
                                        :maxNumber="99999" :pictureTypes="10485760" :documnetTypes="10485760" :otherTypes="10485760" :maxSizes="10240"
                                        @listentochildevent="showmessagefromchild1"/>
                        </div>
                        <div class="atlas_group">
                            <div v-for="(item,index) in workInstruction" :key="index" class="show_Picture">

                                <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                                    <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                                    <p>上传中</p>

                                    <div :style="{height:item.uploadProgress + '%'}"
                                         class="upload_progress_shadow"></div>
                                </div>

                                <div v-else class="showSc">
                                    <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                                         :src="item.url" alt='版权登记'/>
                                    <span class="showDelete"><img @click.stop="deleteList_fj(item)" class="showshanchu"
                                                                  src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                                </div>
                                <Tooltip max-width="300" placement="bottom"
                                         :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                                    <div style="line-height: 1">{{item.name ?
                                        item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>



            <Row class-name="row_item">
                <Col class="col_label"><p>创作开始时间：</p></Col>
                <Col class="col_value">
                    <DatePicker type="date" v-model="form.completeDateBegin" :options="options_create"
                                @on-change = "changeCompleteDateBegin"
                                :value="form.completeDateBegin" placeholder="请选择创作开始时间"
                                class="datePickerClass selectWidth"></DatePicker>
                </Col>
            </Row>

            <Row class-name="row_item">
                <Col class="col_label"><p>创作完成时间：</p></Col>
                <Col class="col_value">
                    <DatePicker type="date" v-model="form.completeDateEnd"  :options="options_create2"
                                @on-change = "changeCompleteDateEnd"
                                :value="form.completeDateEnd" placeholder="请选择创作完成时间"
                                class="datePickerClass selectWidth"></DatePicker>
                </Col>
            </Row>

            <Row class-name="row_item">
                <Col class="col_label"><p>作品完成地点：</p></Col>
                <Col class="col_value">
                    <el-cascader
                            v-model="placeOfCompletion"
                            :options="citys"
                            @change="placeOfCompletionChange"
                            placeholder="国家/省/市"
                            class="selectWidth"></el-cascader>
                    <input v-if="placeOfCompletion[0]=='其他'" v-model.trim="form.completeCity" placeholder="请输入作品完成地点"
                           class="form_input_1" style="width: 180px;margin-left: 15px;" maxlength="50"/>
                </Col>
            </Row>

            <Row class-name="row_item">
                <Col class="col_label"><p>作品发表状态：</p></Col>
                <Col class="col_value">
                    <div style="display: flex;">
                        <Select v-model="form.publishStatus" placeholder="请选择发表状态" style="width: 160px">
                            <Option v-for="(option, index) in publishStatusArr" :value="option.value" :key="index">
                                {{option.label}}
                            </Option>
                        </Select>

                    </div>
                </Col>
            </Row>
            <Row class-name="row_item" v-if="form.publishStatus == '1'" style="margin-top: -10px;">
                <Col class="col_label"><p></p></Col>
                <Col class="col_value">
                    <div style="display: flex;">

                        <div class="publish_status">
                            <span class="pulish_status_span" style=" margin-left: 0;">作品发表时间</span>
                            <DatePicker type="date" v-model="form.publishDate" :options="options_publish"
                                        placeholder="选择日期" class="datePickerClass" style="width: 140px;"></DatePicker>
                            <span class="pulish_status_span">作品发表地点</span>

                            <el-cascader v-model="placeOfPublication"
                                         :props="{ value: 'label' }"
                                         @change="placeOfPublicationChange"
                                         placeholder="国家/省/市"
                                         :options="citys"></el-cascader>
                            <input v-if="placeOfPublication[0]=='其他'" v-model.trim="form.publishCity"
                                   placeholder="请输入作品发表地点" class="form_input_1"
                                   style="width: 180px;margin-left: 15px;" maxlength="50"/>
                            <span class="pulish_status_span">作品发表地址</span>
                            <input v-model.trim="form.publishUrl" placeholder="请输入作品发表地址" class="form_input_1"  style="width: 220px;" />
                        </div>
                    </div>
                </Col>
            </Row>



            <Row class-name="row_item_1" style="min-height: 130px;"
                 v-show="form.copyrightType=='2' || form.copyrightType=='4' || form.copyrightType=='5'">
                <Col class="col_label top20"><p>创作声明：</p></Col>
                <Col class="col_value top20">
                    <slot>
                        <div>
                            <div style="display: flex;align-items: center;">
                                <MyUploadHw
                                        v-show="otherAttachments.length == 0 ?
                                         true :
                                         otherAttachments[0].status ?
                                         otherAttachments[0].status == 'uploading' ?
                                         false :
                                         true :
                                         true "
                                        :index="3"
                                        ref="stateFile"
                                        :oldShowList="otherAttachments"
                                        :fileMultiue="false"
                                        accept=".jpg,.png"
                                        :pictureTypes="10485760"
                                        styleType="btn"
                                        @listentochildevent="showmessagefromchild2"/>

                                <div class="upload_progress_one" v-if="otherAttachments.length == 0 ?
                                         false :
                                         otherAttachments[0].status ?
                                         otherAttachments[0].status == 'uploading' ?
                                         true :
                                         false :
                                         false ">
                                    上传中 {{ otherAttachments[0].uploadProgress }}%

                                    <div :style="{width:otherAttachments[0].uploadProgress + '%'}"
                                         class="upload_progress_one_shadow"></div>
                                </div>

                                <!--                                <Tooltip max-width="400"  v-if="declare_upload_success" placement="top" :content="declare_file_name">-->
                                <!--                                    <span class="declare_upload_success_name">{{ declare_file_name }}</span>-->
                                <!--                                </Tooltip>-->
                                <span style="margin-left: 20px;">{{declare_file_name}}</span>
                                <a :href="[declare_down_urls[form.copyrightType]]" target='_blank' download='合作声明.docx'
                                   class="creatInfo-span">下载模板</a>
                                <span>｜</span>
                                <u class="declare_sample" @click="showDeclareSample">查看样例</u>
                            </div>
                            <div className="tipUpload">
                            </div>
                            <p>温馨提示：请按照模板样例内容仔细填写，注意个人需手写签字，企业需加盖公章，填写完成后拍照上传。格式jpg,png，大小10M以内。</p>
                            <p style="padding-left: 70px;margin-top: 10px;">重新上传，会覆盖原来的文件。</p>
                        </div>
                    </slot>
                </Col>
            </Row>

            <Row class-name="row_item_1" style="min-height: 202px;">
                <Col class="col_label top20"><p>创作过程：</p></Col>
                <Col class="col_value top20">
                    <textarea v-model="form.creationIntentions" placeholder="请输入创作过程,限500字内" maxlength="500"></textarea>
                    <span>(选填)</span>
                </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <hr v-if="form.copyrightType=='2' || form.copyrightType=='4' || form.copyrightType=='5'" style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item_1" style="min-height: 272px;">
                <Col class="col_label top20"><p>权益拥有情况：</p></Col>
                <Col class="col_value top20" >
                    <div style="width: 100%;">
                        <div>
                            <!--                            <img :src="[isSlectedAll?checkedIcon:unCheckedIcon]" class="checkImg">-->
                            <span style="cursor: pointer;" @click="isSlectedAll = !isSlectedAll">
                                <span :class="'checkImg' + [isSlectedAll ? ' active' : '']"></span>
                                <span>全选</span>
                            </span>
                        </div>
                        <div class="owner_checkbox">
                            <div v-for="(item,index) in Ownership" :key="index" :class="[item.checked?'active':'']"
                                 @click="item.checked = !item.checked">
                                <!--                                <input type="checkbox" v-model="item.checked"/><span>{{item.label}}</span>-->
                                <p> {{item.label}}</p>
                                <img src="@/assets/regist/reg_xz.png" alt='版权登记' v-show="item.checked">
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

          <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
          <Row class-name="row_item">
            <Col class="col_label"><p>获奖状态：</p></Col>
            <Col class="col_value">
              <div style="display: flex;">
                <Select v-model="form.awardStatus" placeholder="请选择获奖状态" style="width: 160px">
                  <Option v-for="(option, index) in awardStatusArr" :value="option.value" :key="index">
                    {{option.label}}
                  </Option>
                </Select>

              </div>
            </Col>
          </Row>
          <div class-name="row_item" v-if="form.awardStatus == '1'" style="margin-bottom: 60px;min-height: 372px;">
            <Row class-name="row_item" >
              <Col class="col_label"><p>公开状态：</p></Col>
              <Col class="col_value">
                  <Select v-model="form.openStatus" placeholder="请选择公开状态" style="width: 160px">
                    <Option v-for="(option, index) in openStatusArr" :value="option.value" :key="index">
                      {{option.label}}
                    </Option>
                  </Select>
              </Col>
            </Row>

            <Row class-name="row_item" >
              <Col class="col_label"><p>获奖名称：</p></Col>
              <Col class="col_value">
                  <input placeholder="请输入获奖名称" v-model.trim="form.workAwardName" class="form_input_1" maxlength="100"/>
              </Col>
            </Row>

            <Row class-name="row_item">
              <Col class="col_label"><p>颁奖单位：</p></Col>
              <Col class="col_value">
                  <input placeholder="请输入颁奖单位" v-model.trim="form.workAwardUnit" class="form_input_1" maxlength="100"/>
              </Col>
            </Row>
            <Row class-name="row_item_1" :style="{'height':fileUrl.length>0?'310px':'50px',paddingBottom:'24px',boxSizing:'border-box'}">
              <Col class="col_label top20"><p>证明材料上传：</p></Col>
              <Col class="col_value">
                <div class="certList_right">
                  <div class="certList_right_top">
                    <MyUploadHw :index="1" ref="awardFile" :oldShowList="fileUrl" :fileMultiue="false"
                                textContent="添加证明材料"
                                :maxNumber="1"
                                :accept="pdfFileFormat"
                                :pdfTypes="52428800"
                                :maxSizes="52428800"
                                @listentochildevent="uploadFileUrl"/>


                    <div class="showtextDf">
                      <div>证明材料包括：</div>
                      <p>获奖证书、官方公布的对应文件等，格式限pdf，数量1个，不超过50M</p>
                    </div>
                  </div>
                  <div class="atlas_group">
                    <div v-for="(item,index) in fileUrl" :key="index" class="show_Picture">
                      <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                        <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                        <p>上传中</p>

                        <div :style="{height:item.uploadProgress + '%'}" class="upload_progress_shadow"></div>
                      </div>

                      <!-- <div v-else class="showSc">
                        <span class="showDelete">
                            <img @click.stop="deleteFileUrl(item)" class="showshanchu"  src="@/assets/common/shanchu.png" alt='版权登记'/>
                            </span>
                      </div> -->
                      <div v-else class="showSc">
                            <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" alt='版权登记'/>
                             <span class="showDelete"><img @click.stop="deleteFileUrl(item)" class="showshanchu" src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                        </div>
                      <Tooltip max-width="300" placement="bottom"
                               :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                        <div style="line-height: 1">{{item.name ?
                            item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;" v-if="form.regType == '02'" />

            <div class="certList_w_count_wrap" style="padding-bottom: 40px;" v-if="form.regType == '02'">
                <div style="line-height: 42px;" class="cw_bz_type">办理周期：</div>
                <div class="zhouqiBox">
                    <div class="item" :class="zhouqiIdx == index?'active':''" v-for="(item,index) in zhouqi" :key="index" @click="$route.query.id?'':onZhouqi(index,item)">
                        <div :class="index == 0?'tag':'tag2'">{{item.name}}</div>
                        <div class="text">{{item.text}}</div>
                        <img class="reg_xz" src="@/assets/regist/reg_xz.png" alt='版权登记' v-if="zhouqiIdx == index">
                    </div>
                </div>
            </div>
            <hr v-if="!$route.query.id" style="height:1px;border:none;border-top:1px solid #CBCBCB;" />
            <div class="certList_w_count_wrap" style="padding-bottom: 40px;" v-if="!$route.query.id">
                <div style="line-height: 42px;" class="cw_bz_type">服务费用：</div>
                <div class="cw_ul_type cw_ul_type2">
                    <span>{{(payMoney.bizPrice / 100).toFixed(2)}}</span>元/次
                </div>
            </div>
            <!-- <div v-show="userInfo && userInfo!='' && !isReset ">
                <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
                <Row style="height: auto;" class-name="row_item_1">
                    <Col class="col_label top20"><p>支付方式：</p></Col>
                    <Col class="col_value top20">
                        <component :is="PayWay" @onselected="handlePayWaySelect" type="0202"></component>
                    </Col>
                </Row>
            </div> -->

            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item">
                <Col style="margin: auto;">
                    <button :loading="submitLoading" class="btn_blue" :disabled="isDisabled" @click="addcert">确认提交</button>
                </Col>
            </Row>

            <CertAutorVerify v-if="isAddAutor" :obligeeArr="chooseObligeeArr" :is-radio="powerIsRadio" :my-title="verifyTitle" @fatherModal="chooseAutor"/>
            <DeclareSample v-show="isShowDeclare" :declare-type="declareSrc" @fatherModal="isShowDeclare=false"/>
        </div>
        <div style="height: 60px;"></div>
        <!-- 港安支付 -->
        <payDalog ref="payDalog" :payOrder="payOrder" @confirm="confirm"></payDalog>
        <successfulDalog ref="successfulDalog" :payOrder="payOrder"></successfulDalog>
    </div>


</template>

<script>
    import {cityCode} from "../../../libs/cityCode";
    import {_obligeeList, _getByPage} from "@/api/obligee.js";
    import {configGetBzPrice} from "@/api/index.js";
    import {_save2, getRejectEnablCopyrightRegisterInfo, _resubmit, _getWorkTypeList,updateUrgentInfo, _copyrightGsfwAwardSave} from "../../../api/register";
    import Cookies from "js-cookie";
    import MyUploadHw from '@/views/main-components/my-upload-hw';
    import PayWay from '@/views/main-components/pay-way';
    import Timeline from '@/views/main-components/horizontal-timeline';
    import CertAutorVerify from "./cert-autor-verify";
    import '@/plugins/element.js';
    import DeclareSample from "./declareSample";
    import {_saveData, _getObligeeParams} from "./cpRegistData";

    import payDalog from '@/viewsGangAn/components/payDalog';
    import successfulDalog from '@/viewsGangAn/components/successfulDalog';

    // import ex_cascader from "../../../libs/ex_cascader";
    import "../../../plugins/element.js"
    import util from "../../../libs/util";

    const reImg = /^(bmp|BMP|png|PNG|jpg|JPG|gif|GIF|jpeg|JPEG)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
    const rePdf = /^(pdf)$/;


    export default {
        metaInfo: {
            title: '版权登记|甘肃版权登记',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '版权监测,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "copyrightRegistration",
        components: {
            MyUploadHw,
            Timeline,
            CertAutorVerify,
            DeclareSample,
            PayWay,
            payDalog,
            successfulDalog
        },

        data() {
            return {
                submitLoading: false,
                comp_width: 320,
                test: ["中国", "北京市", "东城区"],
                // test:["0","110000","110101"],
                originObligeeArr: [],//著作权人的数据
                chooseObligeeArr: [], //点击弹窗，里面的内容
                isAddAutor: false, //是否添加作者/著作权人
                citys: [], //城市
                getObligeeParams: [], //获取作者/著作权人的参数

                completeCityIsOther: false,
                ohterCompleteCity: "",
                publishCityIsOther: false,
                ohterPublishCity: "",
                //作品类型
                // workTypes:[{label:"设计手稿",value:"1"},{label:"设计图",value:"2"},{label:"产品摄影",value:"3"},{label:"产品视频",value:"4"},{label:"设计创意稿",value:"5"}],//作品类型
                workTypes: [],//作品类型
                //作品性质
                creativeTypes: [
                    {label: "原创", value: "1"}, {label: "改编", value: "2"}, {label: "翻译", value: "3"},
                    {label: "汇编", value: "4"}, {label: "注释", value: "5"}, {label: "整理", value: "6"}, {
                        label: "其他",
                        value: "7"
                    }
                ],
                publishStatusArr: [{label: "未发表", value: "0"}, {label: "已发表", value: "1"}],

                awardStatusArr: [{label: "未获奖", value: "0"}, {label: "已获奖", value: "1"}],

                openStatusArr: [{label: "未公开", value: "0"}, {label: "已公开", value: "1"}],

                isShowDeclare: false, //显示合作声明图片
                declareSrc: "3", //查看声明图片地址
                declare_down_urls: ["", "", "http://file.bqj.cn/file/acc22d35025a28b80d9bc578bf108b58.docx",
                    "",
                    "http://pub-bluefile.bqj.cn/urkunde/3211eb99fb9c16907cdec30886a2aad0.docx",
                    "http://pub-bluefile.bqj.cn/urkunde/bbd17aee92606185f38f2a6520b99e06.docx"
                ],//声明 下载地址
                declare_file_names: ["", "", "合作作品创作声明", "", "职务作品创作声明", "委托作品创作声明"],
                declare_upload_success: false,
                declare_file_name: "",
                // 1.个人作品 2.合作作品 3.法人作品 4.职务作品 5.委托作品
                powers: [{label: "个人作品", checked: true, value: "1"}, {label: "法人作品", checked: false, value: "3"},
                    {label: "合作作品", checked: false, value: "2"}, {label: "职务作品", checked: false, value: "4"},
                    {label: "委托作品", checked: false, value: "5"}],
                powers2: [
                    {label: "原始", checked: true, value: "1"}
                ],
              creativeTypeList: [
                  {label: "改编、翻译、汇编、整理的原作品已进入公有领域", checked: true, value: "1"},
                  {label: "经过改编、翻译、汇编、整理的作品属于法律认可的不构成侵权的范围", checked: false, value: "2"},
                  {label: "获得原著作权人的授权书", checked: false, value: "3"}
                ],
                powersPerson: [
                  {label: "原始", checked: true, value: "1"},
                  {label: "继承", checked: false, value: "2"}
                ],
                powersEnterprise: [
                  {label: "原始", checked: true, value: "1"},
                  {label: "承受", checked: false, value: "3"}
                ],
                powers_desArr: ["个人作品是指个人独立创作完成的作品。",
                    "合作作品是指两个人或者两人以上共同创作完成的作品。",
                    "法人作品是指以公司的名字创作完成的作品，著作权归属于公司。",
                    "职务作品是指企业事业职工履行工作职责或利用单位组织技术条件创作完成的作品，作品归属于单位，但创作人享有署名权和获得奖励的权力。",
                    "委托作品是指委托他人创作完成的作品，作品的权利归属可以依据委托合同约定。"],
                powers_des: "个人作品是指个人独立创作完成的作品。",
                ////权力权属
                Ownership: [
                    {label: '发表权', value: '1', checked: false},
                    {label: '署名权', value: '2', checked: false},
                    {label: '修改权', value: '3', checked: false},
                    {label: '复制权', value: '5', checked: false},
                    {label: '发行权', value: '6', checked: false},
                    {label: '保护作品完整权', value: '4', checked: false},
                    {label: '出租权', value: '7', checked: false},
                    {label: '展览权', value: '8', checked: false},
                    {label: '表演权', value: '9', checked: false},
                    {label: '放映权', value: '10', checked: false},
                    {label: '广播权', value: '11', checked: false},
                    {label: '信息网络传播权', value: '12', checked: false},
                    {label: '摄制权', value: '13', checked: false},
                    {label: '改编权', value: '14', checked: false},
                    {label: '翻译权', value: '15', checked: false},
                    {label: '汇编权', value: '16', checked: false},
                    {label: '其他', value: '17', checked: false},
                ],//权益拥有情况
                declare_fileAccept: ".png,.jpg",
                declare_fileFormat: [".png", ".jpg"],
                autors: [], //作者
                obligees: [],//权人

                worksList: [],//作品
                workInstruction: [],//附件
                otherAttachments: [],//创作声明
                fileUrl: [],//获奖证明文件
                powerIsRadio: "false",
                maxNumber: 5,
                form: {
                    creativeTypeValue: "",//已进入公共领域等
                    copyrightType: "",	//	权利归属方式. 1.个人作品 2.合作作品 3.法人作品 4.职务作品 5.委托作品
                    regType: '02', //登记类型 02登记 17预登记
                    workFullname: '',//	作品名称
                    url: '' , //	作品url 作品文件
                    workType	:"",	//	 作品类型 ：：
                    workCategory:"", //作品大类
                    authorIds	:"",	//	作者id 以英文逗号分隔
                    obligeeIds	:"",	//	著作权人id 以英文逗号分隔
                    completeCity	:"",	//	创作完成城市
                    completeCountry	:"",	//	创作完成国家
                    completeDateBegin	:"",	//	创作开始时间
                    completeDateEnd	:"",	//	创作完成时间
                    publishStatus	:"",	//	是否首次发表（否：0，是：1）
                    creativeType	:"",	//	作品创作性质 1:原创; 2:改编; 3:翻译; 4:汇编 5:注释; 6:整理; 7:其他
                    powerBy	:"1",	//	权利权属方式：. 1.原始 2.继承 3.承受
                    powerScope	:"",	//	权利范围	权益范围
                    creationIntentions	:"",	//	创作意图
                    creationOriginality	:"",	//	独创性(用来携带创作性质说明)
                    publishUrl: '', //发表地址
                    modifyNumber: "2",   //修改次数
                    otherAttachments: '', //创作说明
                    workInstruction: '', //创作声明
                    awardStatus: '', //获奖状态  0：未获奖   1：获奖
                    openStatus: '',//是否公开 0：未公开  1：已公开
                    workAwardName: '',//奖项名称（已获奖必填）
                    workAwardUnit: '',//颁奖单位（已获奖必填）
                    fileUrl: '',//获奖证明文件 (非必填)

                },
                // 2021-12-2
                auditStatus: '',
                rejectReason: '',
                payMoney: {
                    bizPrice: 0
                },
                payOrder: '',
                zhouqi: [
                    {
                        name: '标准',
                        text: '20工作日出证',
                        code: '020303',
                        state: 1
                    },
                    {
                        name: '加急办理',
                        text: '10工作日出证',
                        code: '020302',
                        state: 2
                    },
                    {
                        name: '加急办理',
                        text: '5工作日出证',
                        code: '020301',
                        state: 2
                    }
                ],
              zhouqiShengNei: [
                {
                  name: '标准',
                  text: '20工作日出证',
                  code: '020306',
                  state: 1
                },
                {
                  name: '加急办理',
                  text: '10工作日出证',
                  code: '020305',
                  state: 2
                },
                {
                  name: '加急办理',
                  text: '5工作日出证',
                  code: '020304',
                  state: 2
                }
              ],
                zhouqiIdx: 0,
                updateUrgentInfodata: {
                    code: '020303',
                    state: 1
                },
                // 2021-12-2end
                copyrightDetailsId: "",
                isReset: false,
                keepAliveData: {},
                oldCopyrightType: "1",
                oldWorkType: "",
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                flagId: '', //存证ID
                PayWay: '',
                isDisabled: false,
                workType_fileAccept: "*",
                rules: {
                    name: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'}
                    ], //音乐名称
                    files: [{required: true, message: '请选择文件', trigger: 'blur'}], //音乐文件
                    autor: [{required: true, message: '请添加权利人', trigger: 'blur'}], //作者
                    obligee: [{required: true, message: '请添加权利人', trigger: 'blur'}],//权人
                },
                music: require('@/assets/common/music_icon.png'),
                text: require('@/assets/common/text_icon.png'),
                video: require('@/assets/common/video_icon.png'),
                other: require('@/assets/common/file_icon.png'),
                unCheckedIcon: require("@/assets/common/unChecked.png"),
                checkedIcon: require("@/assets/common/new_lo_ye.png"),
                options_create: {
                    disabledDate(date) {
                        //如果可以包含当天，那么 就不用减去8640000，如果不能包含当天，则需要减去
                        return date && date.valueOf() > Date.now();
                    }
                },
                options_create2: {
                    disabledDate(date) {
                        return date
                    },
                },

                options_publish: {
                    disabledDate: (date) => {
                        // console.log(this.form.completeDateEnd);
                        let d = new Date(this.form.completeDateEnd);
                        // console.log("d ====>>>> ",d);
                        return date && !(date.valueOf() < Date.now() && date.valueOf() >= d);
                    }
                },
                placeOfCompletion: [], //作品完成地点
                placeOfPublication: [], //作品发表地点
                otherFileFormat:"",
                pdfFileFormat:".pdf",
                newworkTypes: []
            }
        },
        created() {
            this.form.regType = this.$route.query.regType
            console.log(this.form);
            console.log("created :::::::::: ", _saveData);
            this.getWorkTypeList();

            this.configGetBzPrice()

            this.getObligeeParams = _getObligeeParams;
            let _this = this;
            let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : "";
            if (userInfo.accountType == 'person') {
                this.form.copyrightType = '1'
            } else if (userInfo.accountType == 'person') {
                this.form.copyrightType = '3'
            } else {
                 this.form.copyrightType = '1'
            }

            if (this.$route.query.id && this.$route.query.id != '') {
                this.copyrightDetailsId = this.$route.query.id;
                this.flagId = this.$route.query.id;
                this.isReset = true;
                this.getRejectEnablCopyrightRegisterInfo();
            } else {
                // this.form = JSON.parse(JSON.stringify(_saveData));
            }

            if (userInfo) {
                this.getByPage(this.getObligeeParams.registerId = userInfo.id);
            }
            this.$store.state.app.showPayWay = Cookies.get("userInfo") && Cookies.get("userInfo") != '' ? true : false
            this.PayWay = this.$store.state.app.showPayWay ? 'PayWay' : ''

            if (this.form.completeDateBegin == '') {
              this.options_create2 = {
                disabledDate: (date) => {
                  let d = new Date(new Date(Date.parse("1970-01-01")));
                  return date && !(date.valueOf() < Date.now() && date.valueOf() >= d);
                }
              }
            }
        },
        mounted() {
            this.citys = cityCode;
        },

        computed: {
            isSlectedAll: {
                get() {
                    let isAll = true;
                    this.Ownership.forEach(item => {
                        if (item.checked == false) {
                            isAll = false;
                            return;
                        }
                    })
                    return isAll;
                },
                set(value) {
                    this.selectAll(value);
                }
            }
        },
        methods: {
            confirm(e,orderType) {
                if (e) {
                    this.$refs.successfulDalog.closeDialog(orderType)
                }
            },
            // 面包跳转
            onUrl(url) {
                this.$router.push(url)
            },
            onZhouqi(index,item){
                console.log(item);
                console.log(this.form);
                let that = this
                // 判断身份
                if (that.form.regType == '02') {
                    if (that.obligees.length > 0) {
                        for(let i in that.obligees) {
                            if (that.obligees[i].identityType == 1) {
                                if (that.obligees[i].identityNumber.substring(0,2) == 62) {//省内
                                    if (item.state == 1) {//标准
                                        this.payMoney.bizPrice = 0
                                        this.zhouqiIdx = index,
                                        this.updateUrgentInfodata = this.zhouqiShengNei[0]
                                    } else {//加急
                                        this.zhouqiIdx = index,
                                        this.updateUrgentInfodata = this.zhouqiShengNei[index]
                                        this.configGetBzPrice()
                                    }

                                } else {//省外
                                    this.zhouqiIdx = index,
                                    this.updateUrgentInfodata = item
                                    this.configGetBzPrice()
                                }
                            } else if (that.obligees[i].identityType == 4) {
                                if (that.obligees[i].identityNumber.substring(2,4) == 62) {
                                    if (item.state == 1) {
                                        // this.payMoney.bizPrice = 0
                                        this.zhouqiIdx = index,
                                        this.updateUrgentInfodata = item
                                    } else {
                                        this.zhouqiIdx = index,
                                        this.updateUrgentInfodata = item
                                        this.configGetBzPrice()
                                    }
                                } else {
                                    this.zhouqiIdx = index,
                                    this.updateUrgentInfodata = item
                                    this.configGetBzPrice()
                                }
                            }
                        }
                    } else {
                        this.zhouqiIdx = index,
                        this.updateUrgentInfodata = item
                        this.configGetBzPrice()
                    }
                } else {
                    this.zhouqiIdx = index,
                    this.updateUrgentInfodata = item
                    this.configGetBzPrice()
                }


            },
            // 获取金额
            async configGetBzPrice() {
                let that = this
                let data = {}
                if (this.$route.query.regType == '02') {
                    data = {
                        bizType: '02',
                        subBizType: this.updateUrgentInfodata.code
                    }
                } else {
                    data = {
                        bizType: '17',
                        subBizType: '1701'
                    }
                }
                let res = await configGetBzPrice(data)
                    console.log(that.updateUrgentInfodata);
                // 判断身份
                if (that.form.regType == '02') {
                    if (that.obligees.length > 0) {
                        for(let i in that.obligees) {
                            if (that.obligees[i].identityType == 1) {
                                if (that.obligees[i].identityNumber.substring(0,2) == 62) {

                                    if (that.updateUrgentInfodata.state == 1) {
                                        this.payMoney.bizPrice = 0
                                    } else {
                                        this.payMoney = res.result
                                    }

                                } else {
                                    this.payMoney = res.result
                                }
                            } else if (that.obligees[i].identityType == 4) {
                                if (that.obligees[i].identityNumber.substring(2,4) == 62) {
                                    if (that.updateUrgentInfodata.state == 1) {
                                        this.payMoney.bizPrice = 0
                                    } else {
                                        this.payMoney = res.result
                                    }
                                } else {
                                    this.payMoney = res.result
                                }
                            }
                        }
                    } else {
                        this.payMoney = res.result
                    }
                } else {
                    this.payMoney = res.result
                }

            },
            changeCompleteDateBegin() {
                this.options_create2 =  {
                    disabledDate: (date) => {
                        let d = new Date(this.form.completeDateBegin);
                        return date && !(date.valueOf() < Date.now() && date.valueOf() >= d);
                    }
                }
              if (this.form.completeDateBegin == '') {
                this.options_create2 = {
                  disabledDate: (date) => {
                    let d = new Date(new Date(Date.parse("1970-01-01")));
                    return date && !(date.valueOf() < Date.now() && date.valueOf() >= d);
                  }
                }
              }
            },
            changeCompleteDateEnd(e,w){
                /*if (this.form.completeDateBegin == '') {
                  this.options_create2 = {
                    disabledDate: (date) => {
                      let d = new Date(new Date(Date.parse("1970-01-01")));
                      return date && !(date.valueOf() < Date.now() && date.valueOf() >= d);
                    }
                  }
                }*/

                if(this.form.publishStatus == 1){
                    let a =new Date(e);
                    let b=a.getTime(a);
                    if(this.form.publishDate==""){

                    }else{
                        let c= this.form.publishDate.getTime(this.form.publishDate);
                        if(b>c){
                            this.form.publishDate = ""
                        }
                    }
                }else{
                    this.form.publishDate = ""
                }
            },
            handlePayWaySelect(e) {
                console.log(e);
                this.payWay = e;
            },
            /*********获取作者/著作权人***************/
            async getByPage(parms, flag = false) {
                // //debugger;
                let _this = this;

                let res = await _obligeeList(parms);
                if (res.code == "200") {
                    let data = res.result;
                    let newData = new Array();
                    /*data.forEach(item => {
                        item.checked = false;
                    });*/

                  for (var index = 0; index < data.length; index++) {
                    data[index].checked = false;
                    if (this.form.copyrightType == 1 || this.form.copyrightType == 3) {

                      if (data[index].isRegister == 1) {
                        newData.push(data[index])
                      }
                    }else{
                      newData.push(data[index])
                    }
                  }
                    _this.originObligeeArr = newData;

                    if (flag == true) {
                        //作者处理 originObligeeArr
                        _this.autors = [];
                        if (_this.form.authorIds) {
                            _this.form.authorIds.forEach(value => {
                                console.log(value);
                                for (let i = 0; i < _this.originObligeeArr.length; i++) {
                                    console.log(_this.originObligeeArr[i].id);
                                    if (_this.originObligeeArr[i].id == value)
                                        _this.autors.push(_this.originObligeeArr[i]);
                                }
                            });
                        }
                        //著作权人处理
                        // //debugger ;
                        _this.obligees = [];
                        if (_this.form.obligeeIds) {
                            _this.form.obligeeIds.forEach(value => {
                                for (let i = 0; i < _this.originObligeeArr.length; i++) {
                                    if (_this.originObligeeArr[i].id == value)
                                        _this.obligees.push(_this.originObligeeArr[i]);
                                }
                            });
                        }
                    }
                }

            },
            /************获取登记详情***********/
            getRejectEnablCopyrightRegisterInfo() {
                let _this = this;
                let data = {
                    orderSeqNo: this.copyrightDetailsId
                };

                getRejectEnablCopyrightRegisterInfo(data).then(res => {
                    if (res.code == 200) {

                        // _this.form = JSON.parse(JSON.stringify(_saveData));
                        //后来的数据返回来的是null,但是传值的时候，后端又不接受null
                        let _result = res.result.copyrightRegisterInfo;
                        // let keys = Object.keys(_result);
                        // keys.forEach((key) => {
                        //     if (_result[key] == null) {
                        //         _result[key] = "";
                        //     }
                        // })
                        _this.auditStatus = res.result.auditStatus
                        _this.rejectReason = res.result.rejectReason

                        _this.form = Object.assign(_this.form, _result);
                        _this.form.regType = _this.$route.query.regType


                        if (_this.$route.query.regType == '02') {
                            _this.form.operationType = res.result.operationType
                            _this.form.urgentDayType = res.result.urgentDayType
                        } else {
                            _this.form.operationType = ''
                            _this.form.urgentDayType = ''
                        }

                        _this.zhouqi.forEach( (item,index) => {

                            if ( res.result.urgentDayType == item.code) {
                                _this.zhouqiIdx = index
                            }
                        })

                        //特殊处理，数据库返回来得字段，与传值字段不一样
                        // _this.form.completeDateEnd = _result.completeDateEnd

                        _this.options_create2 =  {
                            disabledDate: (date) => {
                              if(this.form.completeDateBegin == ''){
                                let d = new Date(new Date(Date.parse("1970-01-01")));
                                return date && !(date.valueOf() < Date.now() && date.valueOf() >= d);
                              }else{
                                let d = new Date(this.form.completeDateBegin);
                                return date && !(date.valueOf() < Date.now() && date.valueOf() >= d);
                              }
                            }
                        }



                        _this.form.workType = _this.form.workType;//文字，看一会是不是需要转化成数字
                        for(let i in _this.form.workType){
                            if(_this.form.workType[i].pCode == "other"){
                                let sx = _this.form.workType[i].fileFormat.split('|');
                                let newF = [];
                                sx.map((item) => {
                                    newF.push('.' + item)
                                })
                                _this.otherFileFormat=newF.join(',')
                            }
                        }
                        //作品类型 处理
                        _this.workTypeChange(_this.form.workType)

                        let worksAttachmentses = _this.form.url.split(',');


                        //权力权属，获取到得是文字
                        _this.powers_des = this.powers_desArr[parseInt(_this.form.copyrightType) - 1];
                        _this.oldCopyrightType = _this.form.copyrightType;


                        //作品文件处理
                        _this.worksList = [];
                        // debugger ;
                        worksAttachmentses.forEach((value, index) => {
                            console.log(value);
                            let obj = {};
                            obj.attachmentUrl = value;
                            let layout = value.substring(value.lastIndexOf('.') + 1)
                            if (reImg.test(layout)) {
                                obj.url = util.thumbnail(value);
                            } else if (reMusic.test(layout)) {
                                obj.url = _this.music;
                            } else if (reText.test(layout)) {
                                obj.url = _this.text;
                            } else if (reVideo.test(layout)) {
                                obj.url = _this.video;
                            } else {
                                obj.url = _this.other;
                            }
                            obj.name = value.split('file/')[1]
                            obj.size = (value.attachmentSize) - 0;
                            _this.worksList.push(obj);
                        });


                        //时间得处理

                        //完成 地点得处理
                        let placeOfCompletionReflexion = _this.placeOfCompletionReflexion(_this.form);
                        _this.placeOfCompletion = placeOfCompletionReflexion.placeOfCompletion;


                        //附件处理
                        console.log(_this.form.workInstruction);
                        if (_this.form.workInstruction != null) {
                            _this.workInstruction = [];
                            let workInstruction = (_this.form.workInstruction).split(',');
                            if (workInstruction[0] != "") {
                                workInstruction.forEach((value, index) => {
                                    let obj = {};
                                    obj.attachmentUrl = value;
                                    obj.url = util.thumbnail(value);
                                    let layout = value.substring(value.lastIndexOf('.') + 1)
                                    if(reImg.test(layout)){
                                        obj.url = util.thumbnail(obj.url);
                                    }else if(reMusic.test(layout)){
                                        obj.url = _this.music;
                                    }else if(reText.test(layout)){
                                        obj.url = _this.text;
                                    }else if(reVideo.test(layout)){
                                        obj.url = _this.video;
                                    }else{
                                        obj.url = _this.other;
                                    }
                                    obj.name = "附件" + (index + 1) + "." + layout;

                                    _this.workInstruction.push(obj);
                                });
                            } else {
                                _this.form.workInstruction = "";
                            }
                        }

                      //获奖证明材料
                      console.log(_this.form.fileUrl );
                      if (_this.form.fileUrl != null) {
                        _this.fileUrl = [];
                        let fileUrl = (_this.form.fileUrl).split(',');
                        alert(fileUrl);
                        if (fileUrl[0] != "") {
                          fileUrl.forEach((value, index) => {
                            let obj = {};
                            obj.attachmentUrl = value;
                            obj.url = util.thumbnail(value);
                            let layout = value.substring(value.lastIndexOf('.') + 1)
                            obj.url = _this.other;

                            obj.name = "获奖证明材料" + (index + 1) + "." + layout;

                            _this.fileUrl.push(obj);
                          });
                        } else {
                          _this.form.fileUrl = "";
                        }
                      }


                        //发表地点的 处理
                        let placeOfPublicationReflexion = _this.placeOfPublicationReflexion(_this.form);
                        _this.placeOfPublication = placeOfPublicationReflexion.placeOfPublication;

                        //创作声明
                        if (_this.form.copyrightType == "2" || _this.form.copyrightType == "4" || _this.form.copyrightType == "5") {

                            _this.otherAttachments[0] = {
                                attachmentUrl: _this.form.otherAttachments,
                                url: _this.form.otherAttachments,
                                name: "创作声明"
                            };
                            this.declare_file_name = _this.declare_file_names[Number(_this.form.copyrightType)] + _this.form.otherAttachments.substr(_this.form.otherAttachments.length - 4, 4);

                            _this.declare_upload_success = true; //显示创作声明的文本标签是否显示
                        }
                        //权力权益
                        _this.form.powerScope.split(",").forEach(value => {
                            _this.Ownership[value - 1].checked = true;
                        })

                        //创作意图
                        _this.form.creationIntentions = _this.form.creationIntentions;
                        // 作者
                        _this.form.authorIds = _this.form.authorIds.split(',')
                        // 权利人
                        _this.form.obligeeIds = _this.form.obligeeIds.split(',')
                        _this.getByPage('', true);

                    }
                }, (err) => {
                    toast('网络断开连接，请重试')
                })
            },

            //通过名称获取value，用于权力权属，作品类型，作品性质，发表状态
            getValueByLabel(name, originArr) {
                let value = "";
                originArr.forEach(item => {
                    if (item.label == name)
                        value = item.value;
                });
                return value;
            },
            creativeTypeChange(e, q){
              console.log(e, q);
              if(e != 3) {
                this.workInstruction.splice(0, 1);
              }
            },
            powerChange(e, q) {
              this.getByPage()
                console.log(e, q);
                if (!this.checkUploading()) {
                    toast('请上传完成，再进行操作');
                    this.$nextTick(() => {
                        this.form.copyrightType = this.oldCopyrightType;
                    })

                    return false
                }
                let index = parseInt(this.form.copyrightType) - 1;
                this.powers_des = this.powers_desArr[index];
                //如果权力权益发生变化，那么，创作声明都需要重新上传文件
                let currValue = this.form.copyrightType;
                this.declare_file_name = "";
                this.placeOfCompletion = [];
                this.placeOfPublication = [];
                this.declare_upload_success = false;
                // if(this.keepAliveData[this.oldCopyrightType] == null){
                var obj = {};
                obj.form = {...this.form};
                obj.autors = [...this.autors];
                obj.obligees = [...this.obligees];
                obj.worksList = [...this.worksList];//作品
                obj.workInstruction = [...this.workInstruction];//附件
                obj.fileUrl = [...this.fileUrl]//获奖证明文件
                obj.otherAttachments = [...this.otherAttachments];//创作声明
                obj.Ownership = JSON.parse(JSON.stringify(this.Ownership)); //权益拥有情况
                obj.Ownership = JSON.parse(JSON.stringify(this.Ownership)); //权益拥有情况
                //完成 地点得处理
                let placeOfCompletionReflexion = this.placeOfCompletionReflexion(obj.form);
                obj.placeOfCompletion = placeOfCompletionReflexion.placeOfCompletion;
                //发表地点得处理
                let placeOfPublicationReflexion = this.placeOfPublicationReflexion(obj.form);
                obj.placeOfPublication = placeOfPublicationReflexion.placeOfPublication;


                this.keepAliveData[this.oldCopyrightType] = {...obj};
                // }
                //把当前的权利归属字段赋给记录字段
                this.oldCopyrightType = this.form.copyrightType;

                if (this.keepAliveData[this.form.copyrightType] != null) {
                    let obj = {...this.keepAliveData[this.form.copyrightType]};
                    this.form = obj.form;
                    this.autors = obj.autors;
                    this.obligees = obj.obligees;
                    this.worksList = obj.worksList;
                    this.workInstruction = obj.workInstruction;
                    this.fileUrl = obj.fileUrl;
                    this.otherAttachments = obj.otherAttachments;
                    this.Ownership = obj.Ownership;
                    this.placeOfCompletion = obj.placeOfCompletion;
                    this.placeOfPublication = obj.placeOfPublication
                    console.log(this.otherAttachments)
                    if (this.otherAttachments && this.otherAttachments.length != '') {
                        // if(_this.form.creativeType != "1") {
                        //     this.declare_file_name = '作品创作说明书' + _this.form.workInstruction.substr(_this.form.workInstruction.length - 4, 4);
                        // } else {
                        //     this.declare_file_name = this.declare_file_names[Number(this.form.copyrightType)] + this.form.workInstruction.substr(this.form.workInstruction.length - 4, 4);
                        // }
                        this.declare_file_name = this.declare_file_names[Number(this.form.copyrightType)] + this.form.workInstruction.substr(this.form.workInstruction.length - 4, 4);

                        this.declare_upload_success = true;
                    }
                } else {
                    if (currValue == "2" || currValue == '4' || currValue == '5') {
                        this.$refs['stateFile'].clearUploadList();
                    }
                    // this.form = JSON.parse(JSON.stringify(_saveData));
                    this.autors = [];
                    this.obligees = [];
                    this.worksList = [];
                    this.otherAttachments = [];
                    this.workInstruction = [];
                    this.isSlectedAll = false;
                }

                this.$refs["workFile"].clearUploadList();
                if (this.form.creativeType != '1' && this.form.creativeType != '') {
                    this.$refs['encolosureFile'].clearUploadList();
                }
                // this.$refs["awardFile"].clearUploadList();

                this.$refs['stateFile'].clearUploadList();
                this.workTypeChange(this.form.workType)
                //这里需要把当前的权利归属字段重新赋值给form,因为这里form进行了重新赋值，而_saveData里面，权利归属的初始值是1，是个人
                this.form.copyrightType = currValue;

            },
            powerChange2() {

            },
            //作品类型发生改变
            workTypeChange(e) {
                console.log(e);
                if (!e || e == '') {
                    this.$refs['worksType'].clearSingleSelect();
                    this.form.workType = !e ? '' : e;
                    this.form.workCategory = '';
                    this.workType_fileAccept = '*';
                    this.oldWorkType = !e ? '' : e;
                    return false
                }


                let oldWorkType = this.oldWorkType;
                let workTypes = this.workTypes;
                let workItem = '';
                let fileFormat = ''
                let wl = this.worksList;

                for (let k = 0; k < wl.length; k++) {
                    if (wl[k].status && wl[k].status == 'uploading') {
                        toast('请上传完成后，再进行操作');
                        this.$nextTick(() => {
                            this.form.workType = oldWorkType;
                        })
                        return;
                    }
                }


                // for (let i = 0; i < workTypes.length; i++) {
                //     if (e == workTypes[i].code) {
                //         workItem = workTypes[i];
                //         break;
                //     }
                // }
                for(let i in this.newworkTypes) {
                    for(let k in this.newworkTypes[i].workTypes) {
                        for(let j in this.newworkTypes[i].workTypes[k]) {
                            if (e == j) {
                                workItem = this.newworkTypes[i].workCategory
                                fileFormat = this.newworkTypes[i].fileFormat
                            }
                        }
                    }
                }
                this.form.workCategory = workItem
                this.workType_fileAccept = fileFormat;
                console.log(this.workType_fileAccept);


                // if(fileFormat!='*'){
                //     if (wl.length > 0) {
                //         let j = wl.length;
                //         while (j--) {
                //             let layout = wl[j].attachmentUrl.substring(wl[j].attachmentUrl.lastIndexOf('.') + 1);
                //             if (this.workType_fileAccept.indexOf(layout) == -1) {
                //                 wl.splice(j, 1);
                //             }
                //         }
                //     }
                // }


                this.oldWorkType = e;

            },
            //添加作者，弹出添加作者窗口
            addAutor(flag) {
                if (!this.checkLogin()) {
                    return false
                }
                this.getByPage()
                this.autorOrObligee = flag;
                this.verifyTitle = this.autorOrObligee == "autor" ? "添加作者" : "添加著作权人";
                //个人作品，作者和著作权人是一个人，选择一个  obligeeType person：“个人” enterprise “企业”
                this.powerIsRadio = "false"; //false 复选，true：单选
                let data = [];
                this.chooseObligeeArr = [];
                // //debugger ;
                if (this.form.copyrightType == "1") {
                    data = this.originObligeeArr.filter(item => {
                        return item.obligeeType == "person";
                    });
                    if (data.length == 0) {
                        /*toast("您还没有添加个人权利人，请先添加个人权利人再来登记");*/
                        toast("请先实名认证");
                        this.$router.push('/authentication')
                        return false;
                    }
                    this.powerIsRadio = "true";
                }
                // 法人作品，作者和著作权人只能是企业，只能选一个
                else if (this.form.copyrightType == "3") {
                    this.powerIsRadio = "true";
                    data = this.originObligeeArr.filter(item => {
                        return item.obligeeType == "enterprise";
                    });

                    if (data.length == 0) {
                        toast("您还没有添加企业权利人，请先添加企业权利人再来登记");
                        return false;
                    }
                }
                // 职务，作者可以多个，著作权人只能是一个
                else if (this.form.copyrightType == "4" && this.autorOrObligee != "autor") {
                    this.powerIsRadio = "true";
                    data = this.originObligeeArr;
                } else {
                    data = this.originObligeeArr;
                }
                this.chooseObligeeArr = [...data.map(aInfo => {
                    return Object.assign({}, aInfo)
                })]
                this.isAddAutor = true;
            },
            //关闭 添加作者窗口，获取选中得作者
            chooseAutor(data) {
                console.log(data);
                let that = this
                this.isAddAutor = false;
                if (!data) {
                    return false
                }
                //个人作品，作者和著作权人是一个人，选择一个，两个都变
                if (this.form.copyrightType == "1") {
                    this.autors = [...data];
                    this.obligees = [...data];
                }
                //法人作品，作者和著作权人 只能选一个
                else if (this.form.copyrightType == "3") {
                    if (this.autorOrObligee == "autor")
                        this.autors = [...data];
                    else
                        this.obligees = [...data];
                }
                // 职务，著作权人只能是一个
                else if (this.form.copyrightType == "4" && this.autorOrObligee != "autor") {
                    this.obligees = [...data];
                } else {
                    if (this.autorOrObligee === "autor") {
                        let arr = [...this.autors, ...data];
                        this.autors = arr.reduce((acc, cur) => {
                            !acc.some(v => v.name === cur.name) && acc.push(cur);
                            return acc;
                        }, []);
                    } else if (this.autorOrObligee === "obligee") {
                        let arr = [...this.obligees, ...data];
                        this.obligees = arr.reduce((acc, cur) => {
                            !acc.some(v => v.name === cur.name) && acc.push(cur);
                            return acc;
                        }, []);
                    }
                }

                // 判断身份
                if (that.form.regType == '02') {
                    if (that.obligees.length > 0) {
                        for(let i in that.obligees) {
                            if (that.obligees[i].identityType == 1) {
                                if (that.obligees[i].identityNumber.substring(0,2) == 62) {
                                    if (that.updateUrgentInfodata.state == 1) {
                                        this.payMoney.bizPrice = 0
                                    } else {
                                        this.configGetBzPrice()
                                    }
                                } else {
                                    this.configGetBzPrice()
                                }
                            } else if (that.obligees[i].identityType == 4) {
                                if (that.obligees[i].identityNumber.substring(2,4) == 62) {
                                    if (that.updateUrgentInfodata.state == 1) {
                                        this.payMoney.bizPrice = 0
                                    } else {
                                        this.configGetBzPrice()
                                    }
                                } else {
                                    this.configGetBzPrice()
                                }
                            }
                        }
                    }
                }

            },
            //删除作者
            deleteAutor(item) {
                this.autors.splice(this.autors.indexOf(item), 1);

            },
            //删除著作权人
            deleteObligee(item) {
                this.obligees.splice(this.obligees.indexOf(item), 1);
                this.configGetBzPrice()
            },

            //查看声明样例
            showDeclareSample() {
                this.declareSrc = this.form.copyrightType;
                this.isShowDeclare = true;
            },

            //提交
            addcert() {
                // $("#addcertButton").attr("disabled","disabled");

              this.submitLoading = true;

              let _this = this;
              /*this.$refs.submitBtn.setAttribute("disabled", true);//控制按钮为禁用


              var timeoutObj = setTimeout(function () {
                _this.$refs.submitBtn.removeAttribute('disabled');//将按钮可用
                /!* 清除已设置的setTimeout对象 *!/
                clearTimeout(timeoutObj)
              }, 10000);*/



                if (!this.checkLogin()) {
                    return false
                }
                console.log("form ::: >>> ", _this.form);

              if(_this.autors.length > 5 || _this.obligees.length > 5){
                toast("作者和著作权人最多支持5个");
                return false;
              }
                /**
                 * 判断作者和著作权人
                 * 1 判断是否为空
                 * 2 如果是合作作品 ，则作者和著作权人都必须大于等于2
                 */
                if (_this.autors.length <= 0 || _this.obligees.length <= 0) {
                    toast("请选择作者和著作权人");
                    return false;
                } else if (_this.form.copyrightType == "2" && (_this.autors.length < 2 || _this.obligees.length < 2)) {
                    toast("合作作品，作者和著作权人都必须大于等于2个");
                    return false;
                } else {
                    let aid = "";
                    let oid = "";
                    _this.autors.forEach(item => {
                        aid += item.id + ",";
                    })
                    _this.obligees.forEach(item => {
                        oid += item.id + ",";
                    })
                    _this.form.authorIds = aid.substr(0, aid.length - 1);
                    _this.form.obligeeIds = oid.substr(0, oid.length - 1);
                }

                //判断 作品类型
                // debugger ;
                if (_this.form.workType == "") {
                    toast("请选择作品类型")
                    return false;
                } else {
                    _this.form.workType = _this.form.workType;
                }

                //判断作品名称
                if (_this.form.workFullname == "") {
                    toast("请填写作品名称")
                    return false;
                }

                if(_this.form.awardStatus == ""){
                  toast("请选择获奖状态")
                  return false;
                }

                //判断作品文件
                if (_this.worksList.length <= 0) {
                    toast("请选择作品文件")
                    return false;
                } else {
                    let chanShowList = _this.worksList;
                    let urls = '';
                    let attachementsName = '';
                    let attachmentsSize = '';
                    for (let i = 0; i < chanShowList.length; i++) {
                        if (chanShowList[i].status && chanShowList[i].status == 'uploading') {

                            toast('请上传完成后，再提交');
                            return false
                        }

                        urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                        attachementsName += i == chanShowList.length - 1 ? chanShowList[i].name : chanShowList[i].name + ',';
                        attachmentsSize += i == chanShowList.length - 1 ? chanShowList[i].size : chanShowList[i].size + ',';
                    }
                    if (urls == '') {
                        toast('请选择要上传的作品文件')
                        return false;
                    } else {
                        _this.form.url = urls;
                        _this.form.attachementsName = attachementsName;
                        _this.form.attachmentsSize = attachmentsSize;
                    }
                }
                // console.log(_this.form);
                //判断作品创作性质
                if (_this.form.creativeType == "") {
                    toast("请选择作品创作性质")
                    return false;
                } else {
                    _this.form.creativeType = _this.form.creativeType;

                    if(_this.form.creativeType != '1') {
                      _this.form.creationOriginality = this.creativeTypeList[parseInt(_this.form.creativeTypeValue) - 1].label;
                    }
                  console.log("================================" + _this.form.creationOriginality);
                }

                // 创作开始时间
                if (_this.form.completeDateBegin != "") {
                    let dt = new Date(_this.form.completeDateBegin);
                    let year = dt.getFullYear();
                    let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
                    let date = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
                    _this.form.completeDateBegin = year + "-" + month + "-" + date;
                }


                // 创作完成时间
                if (_this.form.completeDateEnd == "") {
                    toast("请选择创作完成时间")
                    return false;
                } else {
                    let dt = new Date(_this.form.completeDateEnd);
                    let year = dt.getFullYear();
                    let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
                    let date = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
                    _this.form.completeDateEnd = year + "-" + month + "-" + date;
                }
                //作品完成地点
                if (!_this.placeOfCompletion || _this.placeOfCompletion == "") {
                    toast("请选择作品完成地点")
                    return false;
                } else if (_this.placeOfCompletion[0] == '其他') {
                    if (_this.form.completeCity == "") {
                        toast("请填写作品完成地点")
                        return false;
                    }
                    _this.form.completeCountry = '其他';
                    _this.form.completeProvince = '无';
                } else {
                    _this.form.completeCountry = _this.placeOfCompletion[0];
                    _this.form.completeProvince = _this.placeOfCompletion[1];
                    _this.form.completeCity = _this.placeOfCompletion[2];
                }
                if (!_this.form.publishStatus || _this.form.publishStatus == '') {
                    toast("请选择作品发表状态")
                    return false

                }

              if (_this.form.awardStatus == "1") {
                if (_this.form.openStatus == "") {
                  toast("请选择公开状态")
                  return false;
                }
                if (_this.form.workAwardName == "") {
                  toast("请填写获奖名称")
                  return false;
                }
                if (_this.form.workAwardUnit == "") {
                  toast("请填写颁奖单位")
                  return false;
                }
              }
                _this.form.publishStatus = _this.form.publishStatus[0];
                //发表状态 如果时已发表，则判断发表时候的地点和时间
                if (_this.form.publishStatus == "1") {
                    //发表完成时间
                    if (_this.form.publishDate == "") {
                        toast("请选择作品发表时间")
                        return false;
                    } else {
                        let dt = new Date(_this.form.publishDate);
                        let year = dt.getFullYear();
                        let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
                        let date = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
                        _this.form.publishDate = year + "-" + month + "-" + date;
                    }
                    //发表完成地点
                    console.log("作品发表地点：：：", _this.placeOfPublication);
                    if (!_this.placeOfPublication || _this.placeOfPublication == "") {
                        toast("请选择作品发表地点")
                        return false;
                    } else if (_this.placeOfPublication[0] == '其他') {
                        if (_this.form.publishCity == "") {
                            toast("请填写作品发表地点")
                            return false;
                        }
                        _this.form.publishCountry = '其他';
                        _this.form.publishProvince = '无';
                        // _this.form.publishCity = _this.ohterPublishCity;
                    } else {
                        _this.form.publishCountry = _this.placeOfPublication[0];
                        _this.form.publishProvince = _this.placeOfPublication[1];
                        _this.form.publishCity = _this.placeOfPublication[2];
                    }
                    if (_this.form.publishUrl == "") {
                        toast("请填写作品发表地址")
                        return false;
                    }
                }

                // 附件 也可以为空
                if (_this.workInstruction.length > 0) {
                    let chanShowList = _this.workInstruction;
                    let urls = '';
                    for (let i = 0; i < chanShowList.length; i++) {
                        if (chanShowList[i].status && chanShowList[i].status == 'uploading') {

                            toast('请上传完成后，再提交');
                            return false
                        }
                        urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                    }
                    _this.form.workInstruction = urls;
                }

                if (_this.fileUrl.length > 0) {
                  let chanShowList = _this.fileUrl;
                  let urls = '';
                  for (let i = 0; i < chanShowList.length; i++) {
                    if (chanShowList[i].status && chanShowList[i].status == 'uploading') {

                      toast('请上传完成后再提交');
                      return false
                    }
                    urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                  }
                  _this.form.fileUrl = urls;
                }

                //创作声明的判断
                if (_this.form.copyrightType == "2" || _this.form.copyrightType == "4" || _this.form.copyrightType == "5") {
                    if (_this.otherAttachments.length <= 0) {
                        toast("请选择创作声明")
                        return false;
                    } else {
                        let chanShowList = _this.otherAttachments;
                        let urls = '';
                        for (let i = 0; i < chanShowList.length; i++) {
                            if (chanShowList[i].status && chanShowList[i].status == 'uploading') {
                                toast('请上传完成后，再提交');
                                return false
                            }
                            urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                        }
                        if (_this.urls == '') {
                            toast('请选择要上传的创作声明文件')
                            return false;
                        } else {
                            _this.form.workInstruction = urls;
                        }
                    }
                }
                if(_this.form.creativeType != '1' && _this.form.creativeType != '' && _this.form.creativeTypeValue == '3' && _this.form.workInstruction == ''){
                  toast("请上传创作性质授权书")
                  return false;
                }
                if(_this.form.creativeType != '1' && _this.form.creativeType != '' && _this.form.creativeTypeValue == ''){
                  toast("请选择作品创作性质说明")
                  return false;
                }

                if (_this.updateUrgentInfodata.code == undefined && _this.form.regType == '02' && _this.copyrightDetailsId == '') {
                    toast("请选择办理周期")
                    return false;
                }
                // console.log(_this.form);
                if (_this.form.regType == '02' && _this.copyrightDetailsId == '') {
                    _this.form.urgentDayType = _this.updateUrgentInfodata.code
                    _this.form.operationType = _this.updateUrgentInfodata.state
                } else if (_this.form.regType == '17' && _this.copyrightDetailsId == '')  {
                     _this.form.urgentDayType = ''
                    _this.form.operationType = ''
                }



                //权益拥有情况
                let isHaveSelect = false;
                let powerScopeType = "";
                _this.Ownership.forEach(item => {
                    if (item.checked == true) {
                        isHaveSelect = true;
                        powerScopeType += item.value + ","
                    }
                });
                if (isHaveSelect == false) {
                    toast('请选择权益拥有情况')
                    return false;
                }
                console.log("powerScopeType :: ", powerScopeType);
                _this.form.powerScope = powerScopeType.substr(0, powerScopeType.length - 1);

                //独创性和创作意图可以为空
                // 提交
                //debugger ;
                // console.log("登记的传参  :: ", _this.form);

               let udt = this.zhouqiShengNei[0].code;
               let _bizPrice = (this.payMoney.bizPrice / 100).toFixed(2)
              if(_bizPrice != 0.00) {
                  udt = _this.form.urgentDayType;
               }else{
                _this.form.urgentDayType = udt;
              }

                if (_this.isReset == true) {
                    _this.form.orderSeqNo = _this.copyrightDetailsId;
                    _this.form.powerBy = "1";
                    _this.isDisabled = true;
                    _save2(_this.form).then(res => {
                       if (res.code == 200) {
                           if (_this.copyrightDetailsId) { //驳回编辑不需要支付
                               if (_this.form.regType == '02') {
                                    _this.$router.push('/MyDaftar')
                                } else {
                                    _this.$router.push('/myDci')
                                }
                           } else {
                               _this.resultJ(res, udt);
                           }

                       } else {
                           toast(res.message)
                           _this.isDisabled = false;
                       }

                    })

                } else {

                    _this.isDisabled = true;
                    _save2(_this.form).then(res => {

                        if (res.code == 200) {
                           if (_this.copyrightDetailsId) { //驳回编辑不需要支付
                                if (_this.form.regType == '02') {
                                    _this.$router.push('/MyDaftar')
                                } else {
                                    _this.$router.push('/myDci')
                                }
                           } else {
                             _this.form.orderSeqNo = res.result;
                             _copyrightGsfwAwardSave(_this.form).then(res => {
                               if (res.code == 200) {

                               }
                               _this.form.orderSeqNo = '';
                             })
                               _this.resultJ(res, udt);
                           }

                       } else {

                           toast(res.message)
                            _this.isDisabled = false;
                       }
                    });
                }
            },
            // updateUrgentInfo(orderSeqNo) {
            //     let that = this
            //     let data = {
            //         orderSeqNo: orderSeqNo,
            //         urgentDayType: this.updateUrgentInfodata.code,
            //         operationType: this.updateUrgentInfodata.state,
            //     }
            //     updateUrgentInfo(data).then( res => {


            //         if (res.code == 200) {
            //             that.resultJ(res,orderSeqNo)
            //         } else {
            //             toast(res.message)
            //             that.isDisabled = false
            //             return false
            //         }
            //     })
            // },
            resultJ(res,urgentDayType) {
                if (res.code == 200) {
                    this.payOrder = res.result
                    let cpayMoney = (this.payMoney.bizPrice / 100).toFixed(2)
                    let orderSeqNo = {
                        orderSeqNo: res.result
                    }
                    let formText = ''
                    if (this.form.regType == '02') {
                        formText = 'copyrightRegistration02'
                    } else {
                        formText = 'copyrightRegistration17'
                    }
                    this.isDisabled = false
                    this.$refs.payDalog.getPayInfoByOrderSeqNo(orderSeqNo, cpayMoney, formText, urgentDayType)
                    this.submitLoading = false;
                    // toast('登记保存成功')
                    // this.$router.push({path: '/myDci'})
                } else if (res.code == 213) {
                    toast("请实名认证后使用功能")
                    this.$router.push('/authentication')
                } else if (res.code == 214) {
                    toast("请购买会员后使用功能")
                    if (userInfo.accountType == "person") {
                        this.$router.push('/vipPersonal')
                    } else {
                        this.$router.push('/vipEnterprise')
                    }
                } else if (res.code == 216) {
                    // this.monitorBagState = true;
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false
                } else if (res.code == 215) {
                    toast("VIP已到期，请续费")
                    this.myczPayState = true;
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false
                } else {
                    toast(res.message)
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false
                }

            },
            //上传作品文件
            showmessagefromchild(data) {

                let _this = this;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].status && data[i].status == 'uploading') {
                        // console.log('没完成')
                        break
                    }
                    let layout = data[i].name.substring(data[i].name.lastIndexOf('.') + 1)

                    if (reImg.test(layout)) {
                        // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                        //     data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                        // }
                        data[i].url = util.thumbnail(data[i].url);
                    } else if (reMusic.test(layout)) {
                        data[i].url = _this.music;
                    } else if (reText.test(layout)) {
                        data[i].url = _this.text;
                    } else if (reVideo.test(layout)) {
                        data[i].url = _this.video;
                    } else {
                        data[i].url = _this.other;
                    }
                }

                _this.worksList = data;
                this.$forceUpdate()

            },
          //上传获奖证明文件
          uploadFileUrl(data) {
            let _this = this;
              if (data[0].status && data[0].status == 'uploading') {
                // console.log('没完成')
              }
            let layout = data[0].attachmentUrl.substring(data[0].attachmentUrl.lastIndexOf('.') + 1)
            if (rePdf.test(layout)) {
              data[0].url = _this.text;
            }
            _this.fileUrl = data;
            this.$forceUpdate()

          },
            //删除作品文件
            deleteList(item) {
                // //debugger ;
                this.worksList.splice(this.worksList.indexOf(item), 1);
            },
          deleteFileUrl(item) {
            // //debugger ;
            this.fileUrl.splice(this.fileUrl.indexOf(item), 1);
          },
            //上传附件
            showmessagefromchild1(data) {
                console.log(data);
                let _this = this;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].status && data[i].status == 'uploading') {
                        // console.log('没完成')
                        break
                    }

                    let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
                    if (reImg.test(layout)) {
                        // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                        //     data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                        // }
                        data[i].url = util.thumbnail(data[i].url);
                    } else if (reMusic.test(layout)) {
                        data[i].url = _this.music;
                    } else if (reText.test(layout)) {
                        data[i].url = _this.text;
                    } else if (reVideo.test(layout)) {
                        data[i].url = _this.video;
                    } else {
                        data[i].url = _this.other;
                    }
                }
                _this.workInstruction = data
                this.$forceUpdate()
            },
            //删除附件
            deleteList_fj(item) {
                this.workInstruction.splice(this.workInstruction.indexOf(item), 1);
            },
            //创作声明，只有一个文件
            showmessagefromchild2(data) {
                let _this = this;

                if (data[0].status && data[0].status == 'uploading') {
                    // console.log('没完成')
                } else {
                    let layout = data[0].attachmentUrl.substring(data[0].attachmentUrl.lastIndexOf('.') + 1)
                    if (reImg.test(layout)) {
                        if (data[0].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1) {
                            data[0].url = data[0].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                        }
                    } else {
                        data[0].url = _this.other;
                    }

                    _this.declare_upload_success = true;
                    _this.declare_file_name = _this.declare_file_names[_this.form.copyrightType] + "." + layout;


                }
                console.log('获取接口后的存证数据', data)
                _this.otherAttachments = data
                this.$forceUpdate()
            },
            //权益拥有情况 全选
            selectAll(value) {
                this.Ownership.forEach(item => item.checked = value);
            },

            /***************************获取作品类型列表*************************/
            getWorkTypeList() {
                let _this = this;

                _getWorkTypeList().then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        _this.newworkTypes = res.result
                        let newworkTypes = []
                        for(let i in res.result){
                            newworkTypes.push.apply(newworkTypes,res.result[i].workTypes);
                        }
                        for( let k in newworkTypes) {

                            for(let j in newworkTypes[k]) {

                                _this.workTypes.push(
                                    {
                                        name: newworkTypes[k][j],
                                        code: j,
                                    }
                                )
                            }
                        }

                    } else {
                        toast(res.message)
                    }
                })
            },

            /***************************作品完成地点改变事件*************************/
            placeOfCompletionChange(e) {
                let _this = this;
                //作品完成地点
                if (_this.placeOfCompletion == "") {
                    return false;

                } else if (_this.placeOfCompletion[0] == '其他') {
                    _this.form.completeCity = '';
                    _this.form.completeCountry = '其他';
                    _this.form.completeProvince = '无';
                } else {
                    _this.form.completeCountry = _this.placeOfCompletion[0];
                    _this.form.completeProvince = _this.placeOfCompletion[1];
                    _this.form.completeCity = _this.placeOfCompletion[2];
                }
            },

            /***************************作品发表地点改变事件*************************/
            placeOfPublicationChange(e) {
                let _this = this;

                console.log(e);
                console.log(_this.placeOfPublication)

                if (!_this.placeOfPublication || _this.placeOfPublication == "") {
                    return false;

                } else if (_this.placeOfPublication[0] == '其他') {
                    _this.form.publishCity = '';
                    _this.form.publishCountry = '其他';
                    _this.form.publishProvince = '无';
                } else {
                    _this.form.publishCountry = _this.placeOfPublication[0];
                    _this.form.publishProvince = _this.placeOfPublication[1];
                    _this.form.publishCity = _this.placeOfPublication[2];
                }
            },

            /***************************作品完成地点返显方法*************************/
            placeOfCompletionReflexion(form) {
                console.log(form)
                let arr = [];
                let ohterCompleteCity = '';
                arr.push(form.completeCountry);
                if (form.completeCountry == '其他') {
                    ohterCompleteCity = form.completeCity;
                } else {
                    arr.push(form.completeProvince);
                    arr.push(form.completeCity);
                }

                return {placeOfCompletion: arr, ohterCompleteCity: ohterCompleteCity}
            },

            /***************************作品发表地点返显方法*************************/
            placeOfPublicationReflexion(form) {
                let parr = [];
                let ohterPublishCity = '';
                if (form.publishStatus == "1") {

                    //发表地点的 处理
                    if (form.publishCity != "" || form.publishCity != null) {
                        parr.push(form.publishCountry);
                        if (form.publishCountry == '其他') {
                            ohterPublishCity = form.publishCity;
                        } else {
                            parr.push(form.publishProvince);
                            parr.push(form.publishCity);
                        }
                    }
                }

                return {placeOfPublication: parr}
            },

            /***************************检查登录，打开登录框方法*************************/
            checkLogin() {
                if (Cookies.get("userInfo") && Cookies.get("userInfo") != '') {
                    this.userInfo = JSON.parse(Cookies.get("userInfo"));
                    return true
                } else {
                    this.$store.state.app.showLoginOrRegistter = true;
                    return false;
                }
            },

            /***************************检查是否上传状态*************************/
            checkUploading() {
                //作品文件检查、作品相关权属文件检查、创作声明检查
                var checkFlag = true;
                let worksList = this.worksList; //作品文件
                let workInstruction = this.workInstruction; //作品相关权属文件
                let otherAttachments = this.otherAttachments; //创作声明
                let fileUrl = this.fileUrl;//获奖证明文件

                if (checkFlag && worksList && worksList.length > 0) {
                    for (let i = 0; i < worksList.length; i++) {
                        if (worksList[i].status && worksList[i].status == 'uploading') {
                            checkFlag = false;
                            break;
                        }
                    }
                }


                if (checkFlag && workInstruction && workInstruction.length > 0) {
                    for (let i = 0; i < workInstruction.length; i++) {
                        if (workInstruction[i].status && workInstruction[i].status == 'uploading') {
                            checkFlag = false;
                            break;
                        }
                    }
                }

                if (checkFlag && fileUrl && fileUrl.length > 0) {
                  for (let i = 0; i < fileUrl.length; i++) {
                    if (fileUrl[i].status && fileUrl[i].status == 'uploading') {
                      checkFlag = false;
                      break;
                    }
                  }
                }

                if (checkFlag && otherAttachments && otherAttachments.length > 0) {
                    for (let i = 0; i < otherAttachments.length; i++) {
                        if (otherAttachments[i].status && otherAttachments[i].status == 'uploading') {
                            checkFlag = false;
                            break;
                        }
                    }
                }


                return checkFlag
            }
        },
        watch: {
            "$store.state.app.showPayWay": function () {
                if (this.$store.state.app.showPayWay) {
                    this.userInfo = JSON.parse(Cookies.get("userInfo"));
                    this.flagId = '';
                    this.PayWay = 'PayWay';
                    this.getByPage(this.getObligeeParams.registerId = this.userInfo.id);

                }
            },

        },
    }
</script>

<style lang="less" scoped>
    #copyrightRegistration {
        width: 100%;
        background: #F1F4F8;
        color: #333;
    }
    .myTitleBox{
        .myTitle{
            font-size: 20px;
            font-weight: 700;
            position: relative;
            font-family: 'AlibabaPuHuiTi';
            z-index: 1;
            display: inline-block;
            margin-left: 55px;
            margin-top: 15px;
            margin-bottom: 15px;
            &::after{
                content: '';
                position: absolute;
                width: 50%;
                background: #2196F3;
                height: 6px;
                border-radius: 3px;
                left: 0;
                bottom: 3px;
                z-index: -1;
            }
        }
    }
    .copyrightRegistration {
        width: 1200px;
        background: #FFFFFF;
        box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
        border-radius: 4px;
        margin: 0 auto;
        padding-top: 20px;
        padding-bottom: 60px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        /deep/ .ivu-radio {
            line-height: revert;
        }

        /deep/ .ivu-radio-focus {
            box-shadow: none;
        }

        .row_item {
            width: 100%;
            height: 70px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .row_item_1 {
            width: 100%;
            height: 70px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
        }

        .col_label {
            width: 140px;

            p {
                width: 140px;
                text-align: right;
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 20px;
            }
        }

        .col_value {
            margin-left: 40px;
            display: flex;
            align-items: center;
        }

        .top20 {
            margin-top: 20px;
        }

        .selectWidth {
            width: 320px;
            height: 38px;
        }

        .radio_group .radio_item_name {
            font-size: 14px;
            color: #666666;
            padding-top: 3px;
        }

        .monitor_type .radio_item {
            margin-right: 40px;
            width: 100px;
        }

        .radio_item.ivu-radio-wrapper-checked .radio_item_name {
            color: #666666;
        }

        /deep/ .radio_item .ivu-radio {
            margin-right: 10px;
            .ivu-radio-input{
                display: none;
            }
        }

        /deep/ .radio_item .ivu-radio-inner {
            width: 12px;
            height: 12px;
            border-radius: 0;
            /*border: 1px solid #B5B5B5;*/
        }

        /deep/ .radio_item .ivu-radio-inner {
            width: 12px;
            height: 12px;
            /*background: url(../../../assets/common/unChecked.png) no-repeat;*/
            border-color: #b5b5b5;
            background-size: cover;
        }

        .radio_item .ivu-radio-checked .ivu-radio-inner {
            border-color: #2196F3;
        }

        /deep/ .radio_item .ivu-radio-inner:after {
            width: 12px;
            height: 12px;
            left: -1px;
            top: -1px;
            /*background: url(../../../assets/common/new_lo_ye.png) no-repeat;*/
            background-color: #2196F3;
            /*background-size: cover;*/
        }

        /deep/ .radio_item .ivu-radio-inner:after {
            width: 12px;
            height: 12px;
            left: -1px;
            top: -1px;
            border-radius: 0;
            background-color: #2196F3;
        }

        /deep/ .ivu-select-single .ivu-select-selection {
            height: 38px;
        }

        /deep/ .ivu-select-selection:hover {
            /*border: 1px solid #2196F3;*/
            border-color: #2196F3;
        }

        /deep/ .ivu-select-selection-focused {
            border-color: #2196F3;
        }

        /deep/ .ivu-select-visible .ivu-select-selection {
            border-color: #2196F3;
            box-shadow: none;
        }

        /deep/ .ivu-input:hover {
            border-color: #2196F3;
        }

        /deep/ .ivu-date-picker-focused input {
            box-shadow: none;
            border-color: #2196F3;
        }

        /deep/ .el-cascader:not(.is-disabled):hover .el-input__inner {
            border-color: #2196F3;
        }

        /deep/ .el-cascader .el-input .el-input__inner:focus {
            border-color: #2196F3;
        }

        /deep/ .el-cascader .el-input.is-focus .el-input__inner {
            border-color: #2196F3;
        }

        /deep/ .row_item .ivu-select-selection .ivu-select-selected-value {
            height: 38px;
            line-height: 38px;
        }

        /deep/ .row_item .ivu-select-selection .ivu-select-placeholder {
            height: 38px;
            line-height: 38px;
            color: #999999;
        }

        .certList_right {
            display: flex;
            flex-direction: column;

            .certList_right_top {
                height: 194px;
                display: flex;
                justify-content: flex-start;

                .showtextDf {
                    margin-left: 20px;

                    div {
                        height: 20px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 20px;
                        margin-top: 64px;
                        margin-bottom: 10px;
                    }

                    p {
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 20px;
                    }
                }
            }
        }

        .show_Picture {
            margin-right: 20px;

            div {
                width: 103px;
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 17px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-top: 5px;
            }

            .showSc {
                position: relative;
                height: 70px;
                width: 103px;
                cursor: pointer;

                &:hover {
                    width: 103px;
                    height: 70px;

                    .showDelete {
                        display: block;
                    }
                }

                .showDelete {
                    width: 103px;
                    height: 70px;
                    background: rgba(0, 0, 0, 0.3);
                    display: none;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    text-align: center;
                    overflow: hidden;
                }

                .showshanchu {
                    width: 18px;
                    height: 18px;
                   margin: 28px auto auto auto;
                }

                .showCm {
                    width: 84px;
                    height: 25px;
                    background: rgba(0, 0, 0, 1);
                    border-radius: 6px 6px 0px 0px;
                    opacity: 0.6;
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 25px;
                    text-align: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }

            .showSc_autor {
                position: relative;
                min-width: 108px;
                height: 38px;
                cursor: pointer;
                margin-top: 0px;

                &:hover {
                    min-width: 108px;
                    height: 38px;

                    .showshanchu {
                        display: block;
                    }
                }

                .showshanchu {
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    display: none;
                    /*margin-top:26px;*/
                }
            }
        }

        .show_Picture_autor {
            margin: 10px 20px 10px 0;

            div {
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 17px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-top: 5px;
            }

            .showSc_autor {
                position: relative;
                min-width: 108px;
                height: 38px;
                cursor: pointer;
                margin-top: 0px;

                &:hover {
                    min-width: 108px;
                    height: 38px;

                    .showshanchu {
                        display: block;
                    }
                }

                .showshanchu {
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: 12px;
                    right: 10px;
                    display: none;
                }
            }

            .autors_class {
                height: 38px;
                background: rgba(33, 150, 243, 0.1);
                border-radius: 19px;
                border: 1px solid #2196F3;
                padding-left: 15px;
                padding-right: 30px;
                padding-top: 10px;
                font-size: 14px;
                font-weight: 400;
                color: #2196F3;
                outline: none;
                text-align: center;
            }
        }

        .power_des {
            width: 100%;
            height: 68px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 68px;
            /*padding-left: 40px;*/
            margin-top: 30px;
            margin-bottom: 24px;

        }

        .publish_status {
            display: flex;
            align-items: center;

            .pulish_status_span {
                margin-left: 20px;
                margin-right: 15px;
            }
        }

        .creatInfo-span {
            margin-left: 30px;
            margin-right: 10px;
            width: 56px;
            font-size: 14px;
            font-weight: 400;
            color: #2196F3;
            text-decoration: underline;
        }

        .declare_sample {
            margin-left: 10px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            cursor: pointer;
        }


        .checkImg {
            width: 12px;
            height: 12px;
            margin-right: 10px;
            /*margin-top: 3px;*/
            display: inline-block;
            border: 1px solid #B5B5B5;
            vertical-align: middle;

            &.active {
                background: #2196F3;
                border: none;
            }
        }

        .owner_checkbox {
            width: 895px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            div {
                margin-right: 40px;
                margin-top: 20px;
                height: 38px;
                background: rgba(255, 255, 255, 1);
                border-radius: 19px;
                border: 1px solid rgba(238, 238, 238, 1);
                cursor: pointer;
            }

            p {
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 20px;
                padding-left: 27px;
                padding-top: 8px;
                padding-right: 27px;
            }

            .active {
                background: rgba(33, 150, 243, 0.1);
                border-radius: 19px;
                border: 1px solid #2196F3;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                position: relative;
                p {
                    color: #2196F3;
                }
            }

            img {
                width: 18px;
                height: 19px;
                position: absolute;
                bottom: -5px;
                right: -4px;
            }

        }

        .form_input_btn_select {
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: #2196F3;
            line-height: 17px;
            text-decoration: underline;
            cursor: pointer;
        }

        /deep/ .ivu-input {
            height: 38px;
        }

        /deep/ .ivu-input-suffix i {
            line-height: 38px;
        }

        input {
            width: 320px;
            height: 38px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            border: 1px solid #dcdee2;
            outline: none;
            padding-left: 10px;
            color: #333333;
        }


        textarea {
            width: 610px;
            height: 162px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            border: 1px solid rgba(203, 203, 203, 1);
            outline: none;
            padding-left: 10px;
            padding-top: 10px;
            color: #333333;
        }

        input:focus,
        input:hover,
        textarea:focus,
        textarea:hover {
            border: 1px solid #2196F3;
        }

        /deep/ input::-ms-input-placeholder {
            color: #2196F3;
        }

        /deep/ input::-webkit-input-placeholder {
            color: #999999;
        }

        /deep/ input::-moz-placeholder {
            color: #999999;
        }
    }

    .atlas_group{
        display:flex;
        justify-content:flex-start;
        flex-wrap: wrap;
    }
</style>
<style lang="less" scoped>
    .btn_blue {
        width: 119px;
        height: 40px;
        background: #2196F3;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        line-height: 20px;
        letter-spacing: 1px;
        outline: none;
        border: none;
        cursor: pointer;
    }

    .upload_progress {
        color: #2196F3 !important;
        font-size: 14px;
        text-align: center;
        border: 1px solid #2196F3;
        flex-direction: column;
        display: flex;
        justify-content: center;
        border-radius: 4px;
        cursor: default;


        .upload_progress_desc {
            font-size: 24px;
            font-weight: 500;
            line-height: 33px;
        }

        .upload_progress_shadow {
            position: absolute;
            width: 100%;
            bottom: 0;
            background: rgba(33, 150, 243, 0.3);
            border-radius: 4px;
            transition: all .5s;
        }

    }

    .upload_progress_one {
        width: 138px;
        height: 38px;
        border: 1px solid #2196F3;
        border-radius: 4px;
        margin: 0 2px 8px 0;
        font-size: 14px;
        text-align: center;
        line-height: 38px;
        color: #2196F3;
        position: relative;

        .upload_progress_one_shadow {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background: rgba(33, 150, 243, 0.3);
            border-radius: 4px;
            transition: all .5s;
        }
    }

    .copyrightRegistration .show_Picture .showSc.upload_progress {
        cursor: default;
    }

    .declare_upload_success_name {
        display: inline-block;
        max-width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 20px;

    }
    .topNav{
        display: flex;
        align-items: center;
        width: 1200px;
        margin: auto;
        padding: 18px 0;
        font-size: 14px;
        color:#999999;
        .img{
            width: 16px;
            height: 16px;
        }
        .r{
            margin: 0 10px;
        }
        .active{
            color: #2196F3;
        }
        .text{
            cursor: pointer;
        }
    }
    .topTitle{
        width: 1200px;
        background: #fff;
        margin: auto auto 20px auto;
        text-align: center;
        padding: 33px;
        border-radius: 8px;
        .title{
            text-align: center;
            font-size: 22px;
            font-weight: 700;
            font-family: 'AlibabaPuHuiTi';

        }
        .msg{
            font-size: 14px;
            margin-top: 6px;
            color:#666666;
        }
    }
    .certList_w_count_wrap {
            display:flex;
            justify-content: flex-start;
    }
    .cw_bz_type{
        width:140px;
        text-align: right;
        font-size:14px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:22px;
        margin:30px 0 0px 0;
    }
    .cw_ul_type{
        display:flex;
        justify-content: flex-start;
        margin-top:30px;
        .cw_li_tb{
            margin-right: 20px;
            width: 212px;
            height: 264px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #b9b9b9;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            img{
                margin:20px 0px 20px 20px;
            }
            div{
                height:20px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:20px;
                margin-bottom:10px;
                margin-left:20px;
            }
            p{
                width:172px;
                font-size:12px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:17px;
                margin:0 auto;
            }
        }

    }
    .cw_ul_type2{
        display: block;
        span{
            color: #FF2121;
            font-size: 26px;
            font-weight: 700;
            margin: 0 4px 0 10px;
        }
    }
    .addBtn{
        width: 124px;
        height: 34px;
        line-height: 34px;
        font-size: 14px;
        text-align: center;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #2196F3;
        color: #2196F3;
        cursor: pointer;
    }
    .zhouqiBox{
        display: flex;
        align-items: center;
        margin-top: 20px;
        margin-left: 40px;
        .item{
            width: 206px;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #E5E5E5;
            padding: 30px 0;
            position: relative;
            font-size: 14px;
            color: #666666;
            margin-right: 22px;
            cursor: pointer;
            .reg_xz{
                width: 18px;
                height: 19px;
                position: absolute;
                bottom: -5px;
                right: -4px
            }
            .text{
                text-align: center;
            }
            .tag{
                position: absolute;
                top: 0;
                left: 0;
                font-size: 12px;
                color: #999999;
                background: #E5E5E5;
                border-radius: 8px 0 8px 0;
                width: 70px;
                line-height: 17px;
                text-align: center;
            }
            .tag2{
                position: absolute;
                top: 0;
                left: 0;
                font-size: 12px;
                color: #fff;
                background: #2196F3;
                border-radius: 8px 0 8px 0;
                width: 70px;
                line-height: 17px;
                text-align: center;
            }
        }
        .active{
            background: rgba(33, 150, 243, 0.1);
            border: 1px solid #2196F3;
            position: relative;
            color: #2196F3;
        }
    }
    .shztBox{
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FF8800;
        font-family: 'AlibabaPuHuiTi';
        background: #FFFCF9;
        border: 1px solid #FF9F00;
        height: 50px;
        width: 1200px;
        margin: auto;
        img{
            width: 20px;
            height: 20px;
            margin-right: 15px;
        }
    }
    .shztBox2{
        background: #FFE7E6;
        color: #E70000;
        border: 1px solid #E70000;
    }
</style>
